module.exports = {"210521001":"观音阁街道","210521100":"小市镇","210521101":"草河掌镇","210521102":"草河城镇","210521103":"草河口镇","210521104":"连山关镇","210521106":"清河城镇","210521109":"田师傅镇","210521110":"南甸镇","210521111":"碱厂镇","210521112":"高官镇","210521202":"东营房乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210521.json
// module id = 543
// module chunks = 0